/* wsapi3-banners v1.2 */
/* Deploy Version 2026-10-13 15:07:35 */
/* Deploy Version 2026-09-24 19:11:08 */
/* Deploy Version 2026-07-27 16:11:01 */
wsMain.createModule({
    name: "banners",
    version: '1.2',
    updatedAt: '2026-07-14',
    function: "get",
    options: {
        idealWidth: {
            full: {
                width: '1500',
                height: '300'
            },
            topo: {
                width: '1200',
                height: '300'
            },
            mini: {
                width: '300',
                height: '150'
            },
            tarja: {
                width: '1200',
                height: '90'
            },
            rodape: {
                width: '1200',
                height: '300'
            },
            popup: {
                width: '600',
                height: '400'
            },
        }
    },
    async get() {
        let data = await ApiWS.Calls.banners();

        return wsMain.modules['banners'].create(data);
    },
    create(returnJson) {
        // Declarando Json de Banners
        let banners = returnJson.banners.filter(b => document.querySelector(`*[data-wsjs-banner="${b.tipo}"]`) || b.tipo == 'popup' ? true : false);
        let bannersTypes = banners.map(b => b.tipo);
        bannersTypes = bannersTypes.filter((b, i) => bannersTypes.indexOf(b) === i);
        // Verificando Se Existem Banners
        if (!banners || banners.length == 0) return "Sem Banners";

        let deviceType = document.querySelector('#HD_VRS_MOBILE').value.toLowerCase() == 'false' ? 'D' : 'M';

        if (bannersTypes.indexOf('category_description') == -1) document.querySelectorAll('*[data-wsjs-banner="category_description"]').forEach(elm => elm.remove());
        else document.querySelectorAll('*[data-wsjs-banner="category_description"]').forEach(elm => elm.style.opacity = '');

        banners = banners.filter(b => b.dispositivos == deviceType || b.dispositivos == 'T');

        banners.forEach((b, i) => {
            b.virtualWidth = wsMain.options['banners'].idealWidth[b.tipo]?.width || '1200';
            b.virtualHeight = wsMain.options['banners'].idealWidth[b.tipo]?.height || '300';
            if (b.tipo == 'popup') {
                let vrf = window.sessionStorage.getItem('bannerPopup_' + b.id);
                if (vrf != 'false') {
                    window.sessionStorage.setItem('bannerPopup_' + b.id, 'false');
                    bannerPopUp(b, i);
                }
            }
        });

        function bannerPopUp(banner, indxToRemove) {
            let popupDiv = wsMain.tools.createElm({
                type: 'div',
                attrs: {
                    class: 'banner-popup-modal'
                }
            });

            document.querySelector('body').style.overflow = 'hidden';

            let popupContainer = wsMain.tools.createElm('div');

            let hyperLink = wsMain.tools.createElm({
                type: 'a',
                attrs: {
                    target: banner.target || '',
                    href: banner.url || 'javascript:;'
                }
            });

            if (banner.conteudo) {
                hyperLink.innerHTML = banner.conteudo
            } else {
                // --- INÍCIO AJUSTE: aceita vídeo também ---
                // normaliza URL com possível duplicação do host
                const normalizeMediaUrl = (u) => {
                    if (!u) return u;
                    // Ex.: https://videos-cdn.webstore.net.br/28589/https://videos-cdn.webstore.net.br/28589/teste.webm
                    const secondHttps = u.indexOf('https://', 8);
                    if (secondHttps > 0) return u.substring(secondHttps);
                    return u;
                };
                const src = normalizeMediaUrl(banner.imagem);
                const isVideo = /\.(webm|mp4)(\?|$)/i.test(src) || src.startsWith('data:video');

                if (isVideo) {
                    const video = wsMain.tools.createElm({
                        type: 'video',
                        attrs: {
                            width: banner.virtualWidth,
                            height: banner.virtualHeight,
                            preload: 'auto',
                            muted: '',           // autoplay mobile exige muted
                            autoplay: '',
                            playsinline: '',
                            loop: '',
                            src: src,
                            style: `max-width:100%;height:auto;`
                        }
                    });
                    hyperLink.append(video);
                } else {
                    let img = wsMain.tools.createElm({
                        type: 'img',
                        imgArea: 'banner-popup',
                        attrs: {
                            width: banner.virtualWidth,
                            height: banner.virtualHeight,
                            alt: banner.titulo,
                            src: src
                        }
                    });
                    hyperLink.append(img);
                }
                // --- FIM AJUSTE ---
            }


            popupContainer.append(hyperLink);
            popupContainer.innerHTML += '<span data-wsjs-icon="close"></span>';

            popupDiv.append(popupContainer);

            popupDiv.addEventListener('click', () => {
                popupDiv.setAttribute('style', 'filter: opacity(0)!important;');
                setTimeout(() => {
                    document.querySelector('body').style.overflow = 'auto';
                    popupDiv.remove();
                }, 301);
            });

            try {
                document.querySelector('body').append(popupDiv);
            } catch (err) { }
        }

        bannersTypes.forEach(actualType => {
            if (actualType == 'popup') return;

            let placeholder = document.querySelector(`[data-wsjs-banner="${actualType}"]`);

            // Se o servidor já renderizou esse tipo de banner (data-ws-rendered="1"), reaproveita
            // o HTML pronto em vez de refazer do zero: evita um segundo request de imagem e o "pulo"
            // de layout do placeholder de lazyload (a imagem do servidor já está carregando/carregada
            // desde o parse inicial do HTML). Só confia nisso se nenhum banner desse tipo tiver
            // "conteudo" customizado — o backend pula esses (banners-server-render.service.ts).
            let hasCustomContent = banners.some(b => b.tipo == actualType && b.conteudo);
            let alreadyRendered = !hasCustomContent && placeholder?.getAttribute('data-ws-rendered') == '1';

            // Banner "full" (o LCP da home) chega do SSR VISÍVEL. Em vez de trocar a prévia pelo
            // carrossel na hora (o que deixava o banner sumido até o slider ficar pronto), o
            // carrossel é montado fora do fluxo, escondido, com a largura da prévia; a prévia
            // continua na tela e só é trocada, numa tacada só, quando o slider já está pronto.
            let stageFull = actualType == 'full' && !!placeholder && !!placeholder.querySelector('img, video');

            let slideContainer = wsMain.tools.createElm({
                type: "div",
                attrs: {
                    id: "banner-" + actualType,
                    class: "banner-holder",
                },
            });

            if (alreadyRendered) {
                Array.from(placeholder.children).forEach(child => {
                    // "full" em staging: a prévia continua na tela, então usa uma cópia (mesma
                    // imagem já em cache, sem request novo) em vez de tirar o filho dela.
                    if (stageFull) child = child.cloneNode(true);
                    // O servidor esconde banners excedentes (além do slides.perView) com
                    // display:none pro "frame inicial" — createSlide() pega TODOS os filhos
                    // do container, e o KeenSlider tenta medir os invisíveis (largura 0),
                    // fazendo a conta de tamanho "explodir". Remove antes de mover: o
                    // KeenSlider passa a controlar quem fica visível de verdade.
                    if (child.style.display === 'none') child.style.display = '';
                    slideContainer.append(child);
                });
            } else banners.forEach(b => {
                if (b.tipo != actualType) return;
                if (b.tipo == "category_description" && b.conteudo.trim() == '' && b.imagem == '') return;

                // Verificando Altura dos Banners
                let imgStyle = "";
                if (b.altura != "0" || b.largura != "0") {
                    if (b.altura != "0" && b.largura != "0") {
                        imgStyle = `width:${b.largura}px;height${b.altura}px`;
                    } else if (b.altura != 0) {
                        imgStyle = `height:${b.altura}px;width:auto;max-width:100%;`;
                    } else if (b.largura != 0) {
                        imgStyle = `width:${b.largura}px`;
                    }
                }

                let bannerImage;

                if (b.conteudo) {
                    let div = wsMain.tools.createElm('div');
                    if (actualType == 'category_description') {
                        let innerElement = document.querySelector('*[data-wsjs-banner="category_description"]').innerHTML.replace('{{value}}', b.conteudo);
                        div.innerHTML = innerElement;
                        bannerImage = div;
                        bannerImage.style.opacity = '';
                    } else {
                        div.innerHTML = b.conteudo;
                        bannerImage = div.firstChild;
                    }
                } else {
                    const normalizeMediaUrl = (u) => {
                        if (!u) return u;
                        const secondHttps = u.indexOf('https://', 8);
                        if (secondHttps > 0) return u.substring(secondHttps);
                        return u;
                    };
                    const mediaSrc = normalizeMediaUrl(b.imagem);
                    const isVideo = /\.(webm|mp4)(\?|$)/i.test(mediaSrc) || mediaSrc.startsWith('data:video');

                    if (isVideo) {
                        // para mini/full/topo usamos autoplay silencioso (UX consistente)
                        bannerImage = wsMain.tools.createElm({
                            type: "video",
                            attrs: {
                                width: '100%',
                                height: '100%',
                                src: mediaSrc,
                                preload: 'auto',
                                muted: '',
                                //controls: 'true',
                                autoplay: '',
                                playsinline: '',
                                loop: '',
                                style: imgStyle
                            }
                        });
                        // --- reforços necessários para alguns browsers (iOS/Safari/Chrome policies) ---
                        try {
                            // garantir propriedades JS
                            bannerImage.muted = true;
                            bannerImage.defaultMuted = true;
                            bannerImage.autoplay = true;
                            // alguns navegadores checam as *propriedades* além dos atributos
                            bannerImage.setAttribute('muted', '');
                            bannerImage.setAttribute('autoplay', '');
                            bannerImage.setAttribute('playsinline', '');
                            bannerImage.setAttribute('loop', '');

                            const tryPlay = () => {
                                const p = bannerImage.play();
                                if (p && typeof p.then === 'function') {
                                    p.catch(() => {/* silencioso: política de autoplay pode negar até ficar visível */ });
                                }
                            };

                            // tenta tocar quando já houver dados suficientes
                            bannerImage.addEventListener('loadeddata', tryPlay, { once: true });
                            bannerImage.addEventListener('canplay', tryPlay, { once: true });

                            // fallback breve após inserir no DOM
                            setTimeout(tryPlay, 50);

                            // play ao primeiro gesto do usuário (garantia extra em iOS mais rígido)
                            const userKick = () => { tryPlay(); bannerImage.removeEventListener('touchstart', userKick); bannerImage.removeEventListener('mouseenter', userKick); };
                            bannerImage.addEventListener('touchstart', userKick, { passive: true });
                            bannerImage.addEventListener('mouseenter', userKick, { passive: true });

                        } catch (_) { }
                    } else {
                        bannerImage = wsMain.tools.createElm({
                            type: "img",
                            lazyLoad: b.tipo == 'full' ? false : true,
                            // Cloudflare Image Resizing (imageResize do head): área "banner-<tipo>",
                            // cai em "banner" se a loja não configurar o tipo — igual ao SSR.
                            imgArea: 'banner-' + b.tipo,
                            attrs: {
                                width: b.virtualWidth,
                                height: b.virtualHeight,
                                src: mediaSrc,
                                alt: b.titulo,
                                style: imgStyle,
                            },
                        });
                    }
                }

                let bannerHiperLink = wsMain.tools.createElm({
                    type: "a",
                    attrs: {
                        href: b.url || 'javascript:;',
                        alt: b.titulo,
                        target: b.target
                    },
                });

                if (actualType == 'category_description') bannerHiperLink = bannerImage;
                else bannerHiperLink.append(bannerImage);

                slideContainer.append(bannerHiperLink);
            });

            if (!slideContainer.hasChildNodes()) return;

            let slideOptions = wsMain.tools.getWsData(placeholder, 'slide')

            // O tipo "full" (banner herói, acima da dobra) não deve entrar no lazy load do
            // slider nem no mobile — é o elemento de LCP da home, atrasá-lo piora LCP e CLS.
            if (deviceType == 'M' && actualType != 'full') slideOptions['lazyLoad'] = true;

            let slideSuccess, slider;

            let vrsMobile = document.querySelector('#HD_VRS_MOBILE').value == 'true';

            // Insere no documento ANTES de montar o slide (era o contrário) — createSlide() faz
            // wsMain.tools.createSlide -> new KeenSlider(...), que mede a largura do container
            // pra calcular o tamanho de cada slide. Chamado num elemento ainda desanexado
            // (slideContainer só é anexado pelo replaceSpanTag logo abaixo), essa medida vem
            // sempre 0 — o slider.update() 5ms depois tenta corrigir, mas nesse meio-tempo o
            // banner (e tudo abaixo dele na página) alterna entre altura 0 e a altura real,
            // gerando o salto que via nos testes de CLS mesmo sem nenhum outro problema visível
            // na seção. Com o elemento já no DOM antes do createSlide(), a medida já sai certa
            // na primeira vez, sem esse vaivém.
            // "full" em staging: fica ao lado da prévia, fora do fluxo (absolute) e com a largura
            // dela, pro createSlide() medir certo sem empurrar nada; a troca é no reveal.
            if (stageFull) {
                slideContainer.style.cssText = `position:absolute;left:0;top:0;width:${placeholder.getBoundingClientRect().width}px;pointer-events:none;`;
                placeholder.setAttribute('data-ws-banner-staged', '1');
                placeholder.after(slideContainer);
            } else wsMain.tools.replaceSpanTag(slideContainer, `banner="${actualType}"`);

            // Entre o replaceSpanTag acima (todos os N itens já no DOM, precisa estar assim pra
            // medida de largura do createSlide() sair certa, ver comentário) e o slider.update()
            // no fim, os itens ficam visíveis "crus" (lista simples, sem o layout de carrossel
            // do KeenSlider aplicado ainda) por um instante — efeito de "pop" antes de virar
            // carrossel de verdade. visibility:hidden (não display:none, que zeraria a largura e
            // quebraria essa mesma medida) esconde só a pintura, sem tirar o espaço do layout —
            // não adiciona salto novo (o container já ocupa o espaço certo, calculado com o
            // conteúdo real), só evita o navegador chegar a pintar esse estado intermediário.
            slideContainer.style.visibility = 'hidden';
            const revealSlideContainer = () => {
                if (stageFull) {
                    // Troca a prévia pelo carrossel pronto no mesmo quadro (sem quadro vazio).
                    ['position', 'left', 'top', 'width', 'pointer-events'].forEach(p => slideContainer.style.removeProperty(p));
                    wsMain.tools.replaceSpanTag(slideContainer, placeholder);
                    slideContainer.removeAttribute('data-ws-banner-staged');
                }
                slideContainer.style.visibility = '';
            };

            if (slideOptions) {
                if (vrsMobile) {
                    [slideSuccess, slider] = wsMain.tools.createSlide(slideContainer, slideOptions);
                    if (!slideSuccess) { revealSlideContainer(); return; }
                } else {
                    if (wsMain.version.compare('1.0.0') == 1) {
                        if (actualType != 'mini' || (actualType == 'mini' && slideContainer.querySelectorAll(':scope > *').length > slideOptions?.slides?.perView)) {
                            [slideSuccess, slider] = wsMain.tools.createSlide(slideContainer, slideOptions);
                            if (!slideSuccess) { revealSlideContainer(); return; }
                        }
                    } else {
                        [slideSuccess, slider] = wsMain.tools.createSlide(slideContainer, slideOptions);
                        if (!slideSuccess) { revealSlideContainer(); return; }
                    }
                }
            }

            // createSlide() com um slide só (ramo "sem carrossel" do wsapi3-main) faz
            // setAttribute('style', 'grid-template-columns: auto;') e apaga o staging acima —
            // o carrossel entrava no fluxo, visível, ao lado da prévia (CLS ~0,25, 30/09).
            if (stageFull) {
                slideContainer.style.position = 'absolute';
                slideContainer.style.left = '0';
                slideContainer.style.top = '0';
                slideContainer.style.width = placeholder.getBoundingClientRect().width + 'px';
                slideContainer.style.pointerEvents = 'none';
                slideContainer.style.visibility = 'hidden';
            }

            setTimeout(() => {
                // reveal antes do update: no staging é ele que põe o carrossel no lugar da
                // prévia, e o update() precisa medir já na posição final (visibility não
                // altera layout, então pros demais tipos a ordem é indiferente).
                revealSlideContainer();
                if (slider) slider.update();
            }, 5);

        });

        try {
            // Prévia do "full" em staging sai no reveal (acima), não aqui.
            document.querySelectorAll('*[data-wsjs-banner]:not([data-ws-banner-staged])').forEach(item => item.remove());
        } catch (_) { }

        // document.querySelectorAll('[data-wsjs-banner]').forEach(item => item.remove());
        return true;
    },
});
